// extracted by mini-css-extract-plugin
export default {"numberInput":"numberInput--IQb1J"};